
import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    setSubmitted(true);
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <Container className="my-5">
      <Row>
        {/* Left side: contact form */}
        <Col md={6}>
          <h2 className="mb-4">📬 Get in Touch</h2>
          {submitted && <Alert variant="success">Thank you! We'll get back to you soon.</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="contactName">
              <Form.Label>Name</Form.Label>
              <Form.Control 
                type="text" 
                name="name" 
                placeholder="Your name"
                value={formData.name}
                onChange={handleChange}
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="contactEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control 
                type="email" 
                name="email" 
                placeholder="Your email"
                value={formData.email}
                onChange={handleChange}
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="contactMessage">
              <Form.Label>Message</Form.Label>
              <Form.Control 
                as="textarea" 
                name="message" 
                rows={4} 
                placeholder="Type your message..."
                value={formData.message}
                onChange={handleChange}
                required 
              />
            </Form.Group>

            <div className="d-grid">
              <Button variant="primary" type="submit">Send Message</Button>
            </div>
          </Form>
        </Col>

        {/* Right side: business details */}
        <Col md={6}>
          <h2 className="mb-4">📞 Contact Details</h2>
          <p><strong>TechTrove</strong></p>
          <p>📍 123 EcoTech Street, Green City, India</p>
          <p>📧 support@techtrove.com</p>
          <p>📞 +91 98765 43210</p>
          <p>🕐 Mon – Fri: 9 AM to 6 PM</p>
          <p>🌐 www.techtrove.com</p>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactForm;

